import type { AiAssistantPanelMode } from "src/components/views/ai/assistant/panel/AiAssistantPanelConstants.ts";

/** Where the AI assistant is shown relative to an open dialog: hidden by it, beside it, or above it. */
export type AavoDialogAiAssistantPlacement = "hidden" | "beside" | "above";

export interface AavoDialogAiAssistantPlacementInput {
	isAiAssistantOpen: boolean;
	aiAssistantPanelMode: AiAssistantPanelMode;
	coverAiAssistant: boolean;
}

/** The side panel is shown beside dialogs and the fullscreen assistant above them, unless the dialog covers it. */
export function getAavoDialogAiAssistantPlacement({
	isAiAssistantOpen,
	aiAssistantPanelMode,
	coverAiAssistant,
}: AavoDialogAiAssistantPlacementInput): AavoDialogAiAssistantPlacement {
	if (!isAiAssistantOpen || coverAiAssistant) return "hidden";
	return aiAssistantPanelMode === "fullscreen" ? "above" : "beside";
}
